import React from 'react';
import MaterialUsagePanel from './material_usage_panel';
import PrintedModelsPanel from './prints_panel';
import PrintersPanel from './printers_panel';
import DashboardLoginContainer from './dashboard-login-container';
import {connect} from 'react-redux';
import AccountSettingPage from './account-setting-container';
import {Elements, StripeProvider} from "react-stripe-elements";
import {stripePublicKey} from "../modules/configs";
import PrinterConnectingTutorial from '../components/printer-connecting-tutorial';
import {UPGRADE_ACCOUNT_LINK} from '../common/constants';
import {SHOW_ACCOUNT_SETTING} from '../actions/types';
import {Redirect} from 'react-router-dom';

class TabbedPages extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
      if (this.props.match.url === UPGRADE_ACCOUNT_LINK) {
        this.props.dispatch({
          type: SHOW_ACCOUNT_SETTING,
        });
        return <Redirect to='/'/>
      }
      return <DashboardLoginContainer showPanelTabs>
        { this.getSelectedPageContent() }
      </DashboardLoginContainer>
  }

  getSelectedPageContent() {
    switch (this.props.selectedPage) {
      case 0:
        return <PrintedModelsPanel/>
      case 1:
        return <PrintersPanel/>
      case 2:
        return <MaterialUsagePanel/>
      case 3:
        return <AccountSettingPage/>
      case 4:
        return <PrinterConnectingTutorial/>
      default:
        return <div/>;
    }
  }
}

export function wrappedWithStripe(page) {
  return <StripeProvider apiKey={stripePublicKey}>
    <Elements>
      { page }
    </Elements>
  </StripeProvider>
}

const mapStateToProps = state => ({ selectedPage: state.userProfile.selectedPage })

export default connect(mapStateToProps)(TabbedPages);



// WEBPACK FOOTER //
// ./src/containers/tabbed_content.js